import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fonctionnalités actives du restaurant (décidées côté serveur). `null` = pas encore chargé → tout visible.
export function useFeatures(slug) {
  const [enabled, setEnabled] = useState(null);
  const reload = useCallback(() => { if (slug) api.getFeatures(slug).then(setEnabled).catch(() => {}); }, [slug]);
  useEffect(() => { reload(); }, [reload]);
  const has = useCallback((k) => enabled === null || enabled.includes(k), [enabled]);
  return { enabled, has, reload };
}

export function FeatureOff({ label }) {
  return (
    <div data-testid="feature-disabled" className="rounded-2xl border border-[#C69C4A]/40 bg-[#C69C4A]/5 p-6 text-center">
      <p className="font-serif-display text-xl text-stone-100">{label} — module non activé</p>
      <p className="text-sm text-stone-400 mt-1">Cette fonctionnalité n'est pas incluse dans votre formule. Contactez NOVANEXT pour l'activer.</p>
    </div>
  );
}
